/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(43);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function (option, success, fail) {
	  var data = option.data || {};
	  var url = option.url;
	
	  if (data.password) {
	    data = JSON.parse(JSON.stringify(data));
	    delete data.password;
	  }
	
	  $.ajax(option).done(function (ret) {
	    success.call(this, ret);
	  }).fail(function (err, status, message) {
	    fail && fail(err, status, message);
	    data.ajaxStatus = status;
	    data.ajaxMessage = message;
	
	    window.onerror(status + ': ' + message, url, -1, -1, {
	      stack: JSON.stringify(data)
	    });
	  });
	};

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Create a simple path alias to allow browserify to resolve
	// the runtime on a supported path.
	module.exports = __webpack_require__(10)['default'];

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	// istanbul ignore next
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }newObj['default'] = obj;return newObj;
	  }
	}
	
	var _handlebarsBase = __webpack_require__(11);
	
	var base = _interopRequireWildcard(_handlebarsBase);
	
	// Each of these augment the Handlebars object. No need to setup here.
	// (This is done to easily share code between commonjs and browse envs)
	
	var _handlebarsSafeString = __webpack_require__(25);
	
	var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);
	
	var _handlebarsException = __webpack_require__(13);
	
	var _handlebarsException2 = _interopRequireDefault(_handlebarsException);
	
	var _handlebarsUtils = __webpack_require__(12);
	
	var Utils = _interopRequireWildcard(_handlebarsUtils);
	
	var _handlebarsRuntime = __webpack_require__(26);
	
	var runtime = _interopRequireWildcard(_handlebarsRuntime);
	
	var _handlebarsNoConflict = __webpack_require__(27);
	
	var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);
	
	// For compatibility and usage outside of module systems, make the Handlebars object a namespace
	function create() {
	  var hb = new base.HandlebarsEnvironment();
	
	  Utils.extend(hb, base);
	  hb.SafeString = _handlebarsSafeString2['default'];
	  hb.Exception = _handlebarsException2['default'];
	  hb.Utils = Utils;
	  hb.escapeExpression = Utils.escapeExpression;
	
	  hb.VM = runtime;
	  hb.template = function (spec) {
	    return runtime.template(spec, hb);
	  };
	
	  return hb;
	}
	
	var inst = create();
	inst.create = create;
	
	_handlebarsNoConflict2['default'](inst);
	
	inst['default'] = inst;
	
	exports['default'] = inst;
	module.exports = exports['default'];

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HandlebarsEnvironment = HandlebarsEnvironment;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	var _utils = __webpack_require__(12);
	
	var _exception = __webpack_require__(13);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	var _helpers = __webpack_require__(14);
	
	var _decorators = __webpack_require__(22);
	
	var _logger = __webpack_require__(24);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var VERSION = '4.0.11';
	exports.VERSION = VERSION;
	var COMPILER_REVISION = 7;
	
	exports.COMPILER_REVISION = COMPILER_REVISION;
	var REVISION_CHANGES = {
	  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
	  2: '== 1.0.0-rc.3',
	  3: '== 1.0.0-rc.4',
	  4: '== 1.x.x',
	  5: '== 2.0.0-alpha.x',
	  6: '>= 2.0.0-beta.1',
	  7: '>= 4.0.0'
	};
	
	exports.REVISION_CHANGES = REVISION_CHANGES;
	var objectType = '[object Object]';
	
	function HandlebarsEnvironment(helpers, partials, decorators) {
	  this.helpers = helpers || {};
	  this.partials = partials || {};
	  this.decorators = decorators || {};
	
	  _helpers.registerDefaultHelpers(this);
	  _decorators.registerDefaultDecorators(this);
	}
	
	HandlebarsEnvironment.prototype = {
	  constructor: HandlebarsEnvironment,
	
	  logger: _logger2['default'],
	  log: _logger2['default'].log,
	
	  registerHelper: function registerHelper(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple helpers');
	      }
	      _utils.extend(this.helpers, name);
	    } else {
	      this.helpers[name] = fn;
	    }
	  },
	  unregisterHelper: function unregisterHelper(name) {
	    delete this.helpers[name];
	  },
	
	  registerPartial: function registerPartial(name, partial) {
	    if (_utils.toString.call(name) === objectType) {
	      _utils.extend(this.partials, name);
	    } else {
	      if (typeof partial === 'undefined') {
	        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
	      }
	      this.partials[name] = partial;
	    }
	  },
	  unregisterPartial: function unregisterPartial(name) {
	    delete this.partials[name];
	  },
	
	  registerDecorator: function registerDecorator(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple decorators');
	      }
	      _utils.extend(this.decorators, name);
	    } else {
	      this.decorators[name] = fn;
	    }
	  },
	  unregisterDecorator: function unregisterDecorator(name) {
	    delete this.decorators[name];
	  }
	};
	
	var log = _logger2['default'].log;
	
	exports.log = log;
	exports.createFrame = _utils.createFrame;
	exports.logger = _logger2['default'];

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.__esModule = true;
	exports.extend = extend;
	exports.indexOf = indexOf;
	exports.escapeExpression = escapeExpression;
	exports.isEmpty = isEmpty;
	exports.createFrame = createFrame;
	exports.blockParams = blockParams;
	exports.appendContextPath = appendContextPath;
	var escape = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#x27;',
	  '`': '&#x60;',
	  '=': '&#x3D;'
	};
	
	var badChars = /[&<>"'`=]/g,
	    possible = /[&<>"'`=]/;
	
	function escapeChar(chr) {
	  return escape[chr];
	}
	
	function extend(obj /* , ...source */) {
	  for (var i = 1; i < arguments.length; i++) {
	    for (var key in arguments[i]) {
	      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
	        obj[key] = arguments[i][key];
	      }
	    }
	  }
	
	  return obj;
	}
	
	var toString = Object.prototype.toString;
	
	exports.toString = toString;
	// Sourced from lodash
	// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
	/* eslint-disable func-style */
	var isFunction = function isFunction(value) {
	  return typeof value === 'function';
	};
	// fallback for older versions of Chrome and Safari
	/* istanbul ignore next */
	if (isFunction(/x/)) {
	  exports.isFunction = isFunction = function isFunction(value) {
	    return typeof value === 'function' && toString.call(value) === '[object Function]';
	  };
	}
	exports.isFunction = isFunction;
	
	/* eslint-enable func-style */
	
	/* istanbul ignore next */
	var isArray = Array.isArray || function (value) {
	  return value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? toString.call(value) === '[object Array]' : false;
	};
	
	exports.isArray = isArray;
	// Older IE versions do not directly support indexOf so we must implement our own, sadly.
	
	function indexOf(array, value) {
	  for (var i = 0, len = array.length; i < len; i++) {
	    if (array[i] === value) {
	      return i;
	    }
	  }
	  return -1;
	}
	
	function escapeExpression(string) {
	  if (typeof string !== 'string') {
	    // don't escape SafeStrings, since they're already safe
	    if (string && string.toHTML) {
	      return string.toHTML();
	    } else if (string == null) {
	      return '';
	    } else if (!string) {
	      return string + '';
	    }
	
	    // Force a string conversion as this will be done by the append regardless and
	    // the regex test will do this transparently behind the scenes, causing issues if
	    // an object's to string has escaped characters in it.
	    string = '' + string;
	  }
	
	  if (!possible.test(string)) {
	    return string;
	  }
	  return string.replace(badChars, escapeChar);
	}
	
	function isEmpty(value) {
	  if (!value && value !== 0) {
	    return true;
	  } else if (isArray(value) && value.length === 0) {
	    return true;
	  } else {
	    return false;
	  }
	}
	
	function createFrame(object) {
	  var frame = extend({}, object);
	  frame._parent = object;
	  return frame;
	}
	
	function blockParams(params, ids) {
	  params.path = ids;
	  return params;
	}
	
	function appendContextPath(contextPath, id) {
	  return (contextPath ? contextPath + '.' : '') + id;
	}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];
	
	function Exception(message, node) {
	  var loc = node && node.loc,
	      line = undefined,
	      column = undefined;
	  if (loc) {
	    line = loc.start.line;
	    column = loc.start.column;
	
	    message += ' - ' + line + ':' + column;
	  }
	
	  var tmp = Error.prototype.constructor.call(this, message);
	
	  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
	  for (var idx = 0; idx < errorProps.length; idx++) {
	    this[errorProps[idx]] = tmp[errorProps[idx]];
	  }
	
	  /* istanbul ignore else */
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, Exception);
	  }
	
	  try {
	    if (loc) {
	      this.lineNumber = line;
	
	      // Work around issue under safari where we can't directly set the column value
	      /* istanbul ignore next */
	      if (Object.defineProperty) {
	        Object.defineProperty(this, 'column', {
	          value: column,
	          enumerable: true
	        });
	      } else {
	        this.column = column;
	      }
	    }
	  } catch (nop) {
	    /* Ignore if the browser is very particular */
	  }
	}
	
	Exception.prototype = new Error();
	
	exports['default'] = Exception;
	module.exports = exports['default'];

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.registerDefaultHelpers = registerDefaultHelpers;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	var _helpersBlockHelperMissing = __webpack_require__(15);
	
	var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);
	
	var _helpersEach = __webpack_require__(16);
	
	var _helpersEach2 = _interopRequireDefault(_helpersEach);
	
	var _helpersHelperMissing = __webpack_require__(17);
	
	var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);
	
	var _helpersIf = __webpack_require__(18);
	
	var _helpersIf2 = _interopRequireDefault(_helpersIf);
	
	var _helpersLog = __webpack_require__(19);
	
	var _helpersLog2 = _interopRequireDefault(_helpersLog);
	
	var _helpersLookup = __webpack_require__(20);
	
	var _helpersLookup2 = _interopRequireDefault(_helpersLookup);
	
	var _helpersWith = __webpack_require__(21);
	
	var _helpersWith2 = _interopRequireDefault(_helpersWith);
	
	function registerDefaultHelpers(instance) {
	  _helpersBlockHelperMissing2['default'](instance);
	  _helpersEach2['default'](instance);
	  _helpersHelperMissing2['default'](instance);
	  _helpersIf2['default'](instance);
	  _helpersLog2['default'](instance);
	  _helpersLookup2['default'](instance);
	  _helpersWith2['default'](instance);
	}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(12);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('blockHelperMissing', function (context, options) {
	    var inverse = options.inverse,
	        fn = options.fn;
	
	    if (context === true) {
	      return fn(this);
	    } else if (context === false || context == null) {
	      return inverse(this);
	    } else if (_utils.isArray(context)) {
	      if (context.length > 0) {
	        if (options.ids) {
	          options.ids = [options.name];
	        }
	
	        return instance.helpers.each(context, options);
	      } else {
	        return inverse(this);
	      }
	    } else {
	      if (options.data && options.ids) {
	        var data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
	        options = { data: data };
	      }
	
	      return fn(context, options);
	    }
	  });
	};
	
	module.exports = exports['default'];

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	var _utils = __webpack_require__(12);
	
	var _exception = __webpack_require__(13);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('each', function (context, options) {
	    if (!options) {
	      throw new _exception2['default']('Must pass iterator to #each');
	    }
	
	    var fn = options.fn,
	        inverse = options.inverse,
	        i = 0,
	        ret = '',
	        data = undefined,
	        contextPath = undefined;
	
	    if (options.data && options.ids) {
	      contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
	    }
	
	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }
	
	    if (options.data) {
	      data = _utils.createFrame(options.data);
	    }
	
	    function execIteration(field, index, last) {
	      if (data) {
	        data.key = field;
	        data.index = index;
	        data.first = index === 0;
	        data.last = !!last;
	
	        if (contextPath) {
	          data.contextPath = contextPath + field;
	        }
	      }
	
	      ret = ret + fn(context[field], {
	        data: data,
	        blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
	      });
	    }
	
	    if (context && (typeof context === 'undefined' ? 'undefined' : _typeof(context)) === 'object') {
	      if (_utils.isArray(context)) {
	        for (var j = context.length; i < j; i++) {
	          if (i in context) {
	            execIteration(i, i, i === context.length - 1);
	          }
	        }
	      } else {
	        var priorKey = undefined;
	
	        for (var key in context) {
	          if (context.hasOwnProperty(key)) {
	            // We're running the iterations one step out of sync so we can detect
	            // the last iteration without have to scan the object twice and create
	            // an itermediate keys array.
	            if (priorKey !== undefined) {
	              execIteration(priorKey, i - 1);
	            }
	            priorKey = key;
	            i++;
	          }
	        }
	        if (priorKey !== undefined) {
	          execIteration(priorKey, i - 1, true);
	        }
	      }
	    }
	
	    if (i === 0) {
	      ret = inverse(this);
	    }
	
	    return ret;
	  });
	};
	
	module.exports = exports['default'];

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	var _exception = __webpack_require__(13);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('helperMissing', function () /* [args, ]options */{
	    if (arguments.length === 1) {
	      // A missing field in a {{foo}} construct.
	      return undefined;
	    } else {
	      // Someone is actually trying to call something, blow up.
	      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
	    }
	  });
	};
	
	module.exports = exports['default'];

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(12);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('if', function (conditional, options) {
	    if (_utils.isFunction(conditional)) {
	      conditional = conditional.call(this);
	    }
	
	    // Default behavior is to render the positive path if the value is truthy and not empty.
	    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
	    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
	    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
	      return options.inverse(this);
	    } else {
	      return options.fn(this);
	    }
	  });
	
	  instance.registerHelper('unless', function (conditional, options) {
	    return instance.helpers['if'].call(this, conditional, { fn: options.inverse, inverse: options.fn, hash: options.hash });
	  });
	};
	
	module.exports = exports['default'];

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (instance) {
	  instance.registerHelper('log', function () /* message, options */{
	    var args = [undefined],
	        options = arguments[arguments.length - 1];
	    for (var i = 0; i < arguments.length - 1; i++) {
	      args.push(arguments[i]);
	    }
	
	    var level = 1;
	    if (options.hash.level != null) {
	      level = options.hash.level;
	    } else if (options.data && options.data.level != null) {
	      level = options.data.level;
	    }
	    args[0] = level;
	
	    instance.log.apply(instance, args);
	  });
	};
	
	module.exports = exports['default'];

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (instance) {
	  instance.registerHelper('lookup', function (obj, field) {
	    return obj && obj[field];
	  });
	};
	
	module.exports = exports['default'];

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(12);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('with', function (context, options) {
	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }
	
	    var fn = options.fn;
	
	    if (!_utils.isEmpty(context)) {
	      var data = options.data;
	      if (options.data && options.ids) {
	        data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
	      }
	
	      return fn(context, {
	        data: data,
	        blockParams: _utils.blockParams([context], [data && data.contextPath])
	      });
	    } else {
	      return options.inverse(this);
	    }
	  });
	};
	
	module.exports = exports['default'];

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.registerDefaultDecorators = registerDefaultDecorators;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	var _decoratorsInline = __webpack_require__(23);
	
	var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);
	
	function registerDefaultDecorators(instance) {
	  _decoratorsInline2['default'](instance);
	}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(12);
	
	exports['default'] = function (instance) {
	  instance.registerDecorator('inline', function (fn, props, container, options) {
	    var ret = fn;
	    if (!props.partials) {
	      props.partials = {};
	      ret = function ret(context, options) {
	        // Create a new partials stack frame prior to exec.
	        var original = container.partials;
	        container.partials = _utils.extend({}, original, props.partials);
	        var ret = fn(context, options);
	        container.partials = original;
	        return ret;
	      };
	    }
	
	    props.partials[options.args[0]] = options.fn;
	
	    return ret;
	  });
	};
	
	module.exports = exports['default'];

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(12);
	
	var logger = {
	  methodMap: ['debug', 'info', 'warn', 'error'],
	  level: 'info',
	
	  // Maps a given level value to the `methodMap` indexes above.
	  lookupLevel: function lookupLevel(level) {
	    if (typeof level === 'string') {
	      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
	      if (levelMap >= 0) {
	        level = levelMap;
	      } else {
	        level = parseInt(level, 10);
	      }
	    }
	
	    return level;
	  },
	
	  // Can be overridden in the host environment
	  log: function log(level) {
	    level = logger.lookupLevel(level);
	
	    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
	      var method = logger.methodMap[level];
	      if (!console[method]) {
	        // eslint-disable-line no-console
	        method = 'log';
	      }
	
	      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        message[_key - 1] = arguments[_key];
	      }
	
	      console[method].apply(console, message); // eslint-disable-line no-console
	    }
	  }
	};
	
	exports['default'] = logger;
	module.exports = exports['default'];

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	// Build out our basic SafeString type
	'use strict';
	
	exports.__esModule = true;
	function SafeString(string) {
	  this.string = string;
	}
	
	SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
	  return '' + this.string;
	};
	
	exports['default'] = SafeString;
	module.exports = exports['default'];

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.__esModule = true;
	exports.checkRevision = checkRevision;
	exports.template = template;
	exports.wrapProgram = wrapProgram;
	exports.resolvePartial = resolvePartial;
	exports.invokePartial = invokePartial;
	exports.noop = noop;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	// istanbul ignore next
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }newObj['default'] = obj;return newObj;
	  }
	}
	
	var _utils = __webpack_require__(12);
	
	var Utils = _interopRequireWildcard(_utils);
	
	var _exception = __webpack_require__(13);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	var _base = __webpack_require__(11);
	
	function checkRevision(compilerInfo) {
	  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
	      currentRevision = _base.COMPILER_REVISION;
	
	  if (compilerRevision !== currentRevision) {
	    if (compilerRevision < currentRevision) {
	      var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
	          compilerVersions = _base.REVISION_CHANGES[compilerRevision];
	      throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
	    } else {
	      // Use the embedded version info since the runtime doesn't know about this revision yet
	      throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
	    }
	  }
	}
	
	function template(templateSpec, env) {
	  /* istanbul ignore next */
	  if (!env) {
	    throw new _exception2['default']('No environment passed to template');
	  }
	  if (!templateSpec || !templateSpec.main) {
	    throw new _exception2['default']('Unknown template object: ' + (typeof templateSpec === 'undefined' ? 'undefined' : _typeof(templateSpec)));
	  }
	
	  templateSpec.main.decorator = templateSpec.main_d;
	
	  // Note: Using env.VM references rather than local var references throughout this section to allow
	  // for external users to override these as psuedo-supported APIs.
	  env.VM.checkRevision(templateSpec.compiler);
	
	  function invokePartialWrapper(partial, context, options) {
	    if (options.hash) {
	      context = Utils.extend({}, context, options.hash);
	      if (options.ids) {
	        options.ids[0] = true;
	      }
	    }
	
	    partial = env.VM.resolvePartial.call(this, partial, context, options);
	    var result = env.VM.invokePartial.call(this, partial, context, options);
	
	    if (result == null && env.compile) {
	      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
	      result = options.partials[options.name](context, options);
	    }
	    if (result != null) {
	      if (options.indent) {
	        var lines = result.split('\n');
	        for (var i = 0, l = lines.length; i < l; i++) {
	          if (!lines[i] && i + 1 === l) {
	            break;
	          }
	
	          lines[i] = options.indent + lines[i];
	        }
	        result = lines.join('\n');
	      }
	      return result;
	    } else {
	      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
	    }
	  }
	
	  // Just add water
	  var container = {
	    strict: function strict(obj, name) {
	      if (!(name in obj)) {
	        throw new _exception2['default']('"' + name + '" not defined in ' + obj);
	      }
	      return obj[name];
	    },
	    lookup: function lookup(depths, name) {
	      var len = depths.length;
	      for (var i = 0; i < len; i++) {
	        if (depths[i] && depths[i][name] != null) {
	          return depths[i][name];
	        }
	      }
	    },
	    lambda: function lambda(current, context) {
	      return typeof current === 'function' ? current.call(context) : current;
	    },
	
	    escapeExpression: Utils.escapeExpression,
	    invokePartial: invokePartialWrapper,
	
	    fn: function fn(i) {
	      var ret = templateSpec[i];
	      ret.decorator = templateSpec[i + '_d'];
	      return ret;
	    },
	
	    programs: [],
	    program: function program(i, data, declaredBlockParams, blockParams, depths) {
	      var programWrapper = this.programs[i],
	          fn = this.fn(i);
	      if (data || depths || blockParams || declaredBlockParams) {
	        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
	      } else if (!programWrapper) {
	        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
	      }
	      return programWrapper;
	    },
	
	    data: function data(value, depth) {
	      while (value && depth--) {
	        value = value._parent;
	      }
	      return value;
	    },
	    merge: function merge(param, common) {
	      var obj = param || common;
	
	      if (param && common && param !== common) {
	        obj = Utils.extend({}, common, param);
	      }
	
	      return obj;
	    },
	    // An empty object to use as replacement for null-contexts
	    nullContext: Object.seal({}),
	
	    noop: env.VM.noop,
	    compilerInfo: templateSpec.compiler
	  };
	
	  function ret(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var data = options.data;
	
	    ret._setup(options);
	    if (!options.partial && templateSpec.useData) {
	      data = initData(context, data);
	    }
	    var depths = undefined,
	        blockParams = templateSpec.useBlockParams ? [] : undefined;
	    if (templateSpec.useDepths) {
	      if (options.depths) {
	        depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
	      } else {
	        depths = [context];
	      }
	    }
	
	    function main(context /*, options*/) {
	      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
	    }
	    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
	    return main(context, options);
	  }
	  ret.isTop = true;
	
	  ret._setup = function (options) {
	    if (!options.partial) {
	      container.helpers = container.merge(options.helpers, env.helpers);
	
	      if (templateSpec.usePartial) {
	        container.partials = container.merge(options.partials, env.partials);
	      }
	      if (templateSpec.usePartial || templateSpec.useDecorators) {
	        container.decorators = container.merge(options.decorators, env.decorators);
	      }
	    } else {
	      container.helpers = options.helpers;
	      container.partials = options.partials;
	      container.decorators = options.decorators;
	    }
	  };
	
	  ret._child = function (i, data, blockParams, depths) {
	    if (templateSpec.useBlockParams && !blockParams) {
	      throw new _exception2['default']('must pass block params');
	    }
	    if (templateSpec.useDepths && !depths) {
	      throw new _exception2['default']('must pass parent depths');
	    }
	
	    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
	  };
	  return ret;
	}
	
	function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
	  function prog(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var currentDepths = depths;
	    if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) {
	      currentDepths = [context].concat(depths);
	    }
	
	    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
	  }
	
	  prog = executeDecorators(fn, prog, container, depths, data, blockParams);
	
	  prog.program = i;
	  prog.depth = depths ? depths.length : 0;
	  prog.blockParams = declaredBlockParams || 0;
	  return prog;
	}
	
	function resolvePartial(partial, context, options) {
	  if (!partial) {
	    if (options.name === '@partial-block') {
	      partial = options.data['partial-block'];
	    } else {
	      partial = options.partials[options.name];
	    }
	  } else if (!partial.call && !options.name) {
	    // This is a dynamic partial that returned a string
	    options.name = partial;
	    partial = options.partials[partial];
	  }
	  return partial;
	}
	
	function invokePartial(partial, context, options) {
	  // Use the current closure context to save the partial-block if this partial
	  var currentPartialBlock = options.data && options.data['partial-block'];
	  options.partial = true;
	  if (options.ids) {
	    options.data.contextPath = options.ids[0] || options.data.contextPath;
	  }
	
	  var partialBlock = undefined;
	  if (options.fn && options.fn !== noop) {
	    (function () {
	      options.data = _base.createFrame(options.data);
	      // Wrapper function to get access to currentPartialBlock from the closure
	      var fn = options.fn;
	      partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
	        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	        // Restore the partial-block from the closure for the execution of the block
	        // i.e. the part inside the block of the partial call.
	        options.data = _base.createFrame(options.data);
	        options.data['partial-block'] = currentPartialBlock;
	        return fn(context, options);
	      };
	      if (fn.partials) {
	        options.partials = Utils.extend({}, options.partials, fn.partials);
	      }
	    })();
	  }
	
	  if (partial === undefined && partialBlock) {
	    partial = partialBlock;
	  }
	
	  if (partial === undefined) {
	    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
	  } else if (partial instanceof Function) {
	    return partial(context, options);
	  }
	}
	
	function noop() {
	  return '';
	}
	
	function initData(context, data) {
	  if (!data || !('root' in data)) {
	    data = data ? _base.createFrame(data) : {};
	    data.root = context;
	  }
	  return data;
	}
	
	function executeDecorators(fn, prog, container, depths, data, blockParams) {
	  if (fn.decorator) {
	    var props = {};
	    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
	    Utils.extend(prog, props);
	  }
	  return prog;
	}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/* global window */
	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (Handlebars) {
	  /* istanbul ignore next */
	  var root = typeof global !== 'undefined' ? global : window,
	      $Handlebars = root.Handlebars;
	  /* istanbul ignore next */
	  Handlebars.noConflict = function () {
	    if (root.Handlebars === Handlebars) {
	      root.Handlebars = $Handlebars;
	    }
	    return Handlebars;
	  };
	};
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// LANG is a macro defined in webpack.config.js
	
	var locale = __webpack_require__(29);
	var __lang__ = '__lang__';
	
	module.exports = function (key, options) {
	    if (!key) {
	        return locale;
	    }
	
	    if (__lang__ === key) {
	        return ('en');
	    }
	
	    options = options || {};
	
	    return locale[key] ? locale[key].replace(/\{\{(\w+)\}\}/g, function (s, $1) {
	        return options[$1];
	    }) : function () {
	
	        console.warn('Key ' + key + ' is not found in locale');
	        return '<?No Translation>';
	    }();
	};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	    "register": "Register",
	    "mobile": "Cellphone No",
	    "or": "or",
	    "registerWithEmail": "register with email",
	    "password": "password",
	    "invitationCode": "invitation code",
	    "getMobileCode": "Get captcha",
	    "mobileCode": "captcha",
	    "notMobileCode": "no captcha?",
	    "submit": "Submit",
	    "haveAccount": "already have an account?",
	    "login": "Login",
	    "userExists": "Username is already taken",
	    "emailInvalid": "Please input a valid email address",
	    "mobileInvalid": "Please input a valid cellphone number",
	    "passwordLength": "Password must contain 6 to 20 characters",
	    "captchaEmpty": "Please finish the validation",
	    "required": "Required",
	    "mobileCodeInvalid": "Please input a valid captcha",
	    "registerWithMobile": "register with cellphone",
	    "email": "Email",
	    "retryMobileCode": "retry",
	    "mobileOrEmail": "cellphone number or email",
	    "forgetPassword": "Forgot password?",
	    "accountInvalid": "Please input a valid cellphone number or email",
	    "account": "Account",
	    "username": "Username",
	    "registerTime": "Register time",
	    "lastLoginTime": "Last login",
	    "edit": "Edit",
	    "save": "Save",
	    "cancel": "Cancel",
	    "myproject": "My Project",
	    "tutorials": "Tutorials",
	    "samples": "Samples",
	    "forum": "Forum",
	    "resetPassword": "Reset password",
	    "resetSuccess": "success",
	    "captchaTipTitle": "The reason why don't you pick up a captcha may be: ",
	    "captchaTip1": "be intercepted into a dustbin by security software",
	    "captchaTip2": "be delayed by the network operator because there is trouble, be patient or click the button",
	    "captchaTip3": "check your cellphone, may be it is down, owing tuition or full of message",
	    "help": "Please join qq group: 598016249, contact the admin",
	    "nicknameExists": "nickname exist",
	    "nicknameLong": "The length of nickname should not be great than {{max}}",
	    "nicknameShort": "The length of nickname should not be less than {{min}}",
	    "point": "Points",
	    "experience": "EXP"
	};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var track = __webpack_require__(31);
	track('user-center-assets', '', function (data) {
		window.handleEnhancerError && window.handleEnhancerError(data);
	});

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	"use strict";
	
	var initError = false;
	var sumitting = false;
	var interval = 2000;
	function reset() {
		setTimeout(function () {
			sumitting = false;
			interval += 2000;
		}, window.enhancerErrorInterval || interval);
	}
	function getCookie(name) {
		var cookieStr;
		var cookies = document.cookie.split(";");
	
		for (var i = 0; i < cookies.length; i++) {
			cookieStr = cookies[i].split("=");
			if (cookieStr && cookieStr[0].replace(/^(\s*)|(\s*)$/g, "") == name) {
				return decodeURI(cookieStr[1]);
			}
		}
	}
	var oldError = window.onerror;
	
	try {
		var errorData = JSON.parse(localStorage.getItem('errorData') || '{}');
		var month = 30 * 24 * 3600 * 1000;
		Object.keys(errorData).forEach(function (key) {
			var item = errorData[key];
			if (Date.now() - item.time > month) {
				delete errorData[key];
			}
		});
		localStorage.setItem('errorData', JSON.stringify(errorData));
	} catch (err) {
		console.error(err);
	}
	module.exports = function (projectName, url, cb) {
		if (initError) {
			return;
		}
		initError = true;
		window.onerror = function (msg, uri, row, col, err) {
			if (msg.toLowerCase() === 'script error.' && !uri) {
				return;
			}
			col = typeof col === 'number' ? col : 0;
			uri = uri || window.location.href;
			var stack = err ? err.stack : '';
			var key = msg + uri + row + col;
	
			try {
				var errorData = JSON.parse(localStorage.getItem('errorData') || '{}');
				if (errorData[key] && errorData[key].stack === stack.toString()) {
					return;
				}
			} catch (err) {
				console.error(err);
			}
	
			try {
				if (sumitting) {
					return;
				}
				sumitting = true;
	
				var submitData = {
					project: projectName,
					msg: msg,
					uri: uri,
					row: row,
					uid: getCookie('uid') || '',
					col: col,
					ua: window.navigator.userAgent,
					stack: stack
				};
				$.ajax({
					url: url || '/tool/error',
					type: 'POST',
					data: submitData
				}).done(function (res) {
					reset();
					try {
						var errorData = JSON.parse(localStorage.getItem('errorData') || '{}');
						errorData[key] = {
							time: Date.now(),
							stack: stack.toString()
						};
						localStorage.setItem('errorData', JSON.stringify(errorData));
					} catch (err) {
						console.error(err);
					}
				}).fail(function () {
					reset();
					console.log(arguments);
				});
	
				if (oldError) {
					oldError.call(window, msg, uri, row, col, err);
				}
				cb && cb(submitData);
			} catch (err) {
				console.log(err);
				reset();
			}
		};
	
		window.addEventListener('error', function (e) {
			var error = e.error;
			if (error) {
				var msg = error.message || e.message || '';
				if (msg.toLowerCase() === 'script error.' && !e.filename && !error.filename) {
					return;
				}
				window.onerror(msg, e.filename, e.lineno, e.colno, error);
			} else {
				var stack = e.target.outerHTML || e.message;
				if (stack.indexOf('hm.baidu.com') === -1) {
					if (!e.message && e.target.outerHTML) {
						stack += ' ---- ';
						var node = e.target.parentNode;
						while (node && node.tagName) {
							stack += '-> ' + node.tagName + '(' + (node.className || node.id || node.src || node.href || '') + ')';
							node = node.parentNode;
						}
					}
					if (e.filename) {
						window.onerror(e.message || 'network error', e.filename, e.lineno || -1, e.colno || -1, { stack: stack });
					}
				}
			}
		}, true);
	};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var i18n = __webpack_require__(28);
	var ajax = __webpack_require__(7);
	
	var util = {};
	
	util.makeZero = function (num) {
	  return num < 10 ? '0' + num : num;
	};
	
	util.format = function (time) {
	  var date = new Date(time);
	  return date.getFullYear() + '-' + util.makeZero(date.getMonth() + 1) + '-' + util.makeZero(date.getDate()) + ' ' + util.makeZero(date.getHours()) + ':' + util.makeZero(date.getMinutes()) + ':' + util.makeZero(date.getSeconds());
	};
	
	util.getCookie = function (name) {
	  var i,
	      cookie,
	      cookieStr,
	      cookies = document.cookie.split(";");
	
	  for (i = 0; i < cookies.length; i++) {
	    cookie = cookies[i];
	    cookieStr = cookie.split("=");
	    if (cookieStr && cookieStr[0].replace(/^(\s*)|(\s*)$/g, "") == name) {
	      return decodeURI(cookieStr[1]);
	    }
	  }
	};
	
	util.setCookie = function (name, value, expire, domain, path, secure) {
	  var date,
	      str = escape(name) + "=" + escape(value);
	  date = new Date();
	
	  date.setTime(date.getTime() + expire);
	  str += domain ? "; domain=" + domain : "";
	  str += path ? "; path=" + path : "";
	  str += expire ? "; expires=" + date.toGMTString() : "";
	  str += secure ? "; secure" : "";
	  document.cookie = str;
	};
	
	util.getUrlParam = function (name) {
	  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	  var r = window.location.search.substr(1).match(reg);
	  if (r != null) return r[2];
	  return null;
	};
	
	$('body').append('<div id="enhancer-util-message" style="\n    position: fixed;\n    top: 50%; \n    left: 50%; \n    padding: 20px;\n    transform: translate(-50%, -50%); \n    border: 1px solid #ccc;\n    color: #f00;\n    border-radius: 3px;\n    background: #fff;\n    max-width: 380px;\n    z-index: 100;\n    display: none;\n"></div>');
	
	util.show = function (msg, type, cb) {
	
	  $('#enhancer-util-message').html(msg).css({
	    color: type === 'error' ? '#f00' : '#000',
	    display: 'block'
	  });
	
	  setTimeout(function () {
	    $('#enhancer-util-message').hide();
	    cb && cb();
	  }, 3000);
	};
	
	util.isMobile = function (val) {
	  return (/^\d{11}$/.test(val)
	  );
	};
	
	util.isEmail = function (val) {
	  var reg = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
	
	  return reg.test(val);
	};
	
	util.isPassword = function (val) {
	  return (/^.{6,20}$/.test(val)
	  );
	};
	
	util.isActiveCode = function (val) {
	  return (/^\d{6}$/.test(val)
	  );
	};
	
	util.countDown = function (ele) {
	  var count = 60;
	  ele = $(ele);
	
	  var oldText = ele.text();
	  ele.text(count + 's ' + i18n('retryMobileCode'));
	
	  var timer = setInterval(function () {
	    count--;
	    if (!count) {
	      clearInterval(timer);
	      ele.prop('disabled', false);
	      ele.text(oldText);
	    } else {
	      ele.text(count + 's ' + i18n('retryMobileCode'));
	    }
	  }, 1000);
	};
	
	util.getActiveCode = function (ele, mobile, cb) {
	  ele.prop('disabled', true);
	  ajax({
	    url: '/sms/code',
	    data: {
	      mobile: mobile
	    }
	  }, function (res) {
	    if (res.success) {
	      util.countDown(ele);
	    } else {
	      ele.prop('disabled', false);
	      console.error(res);
	      if (res.code == 1010 || res.code == 1011 || res.code == 1012) {
	        util.show(res.message);
	      } else {
	        cb && cb();
	      }
	    }
	  }, function (err) {
	    ele.prop('disabled', false);
	  });
	};
	
	util.getScript = function (url, cb) {
	  var script = document.createElement("script");
	  script.src = url;
	  script.crossOrigin = "anonymous";
	  script.onload = cb;
	  document.body.appendChild(script);
	};
	
	module.exports = util;

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(44);
	
	var pageConfig = window.pageConfig;
	var ajax = __webpack_require__(7);
	var resetPassword = __webpack_require__(45);
	var locale = __webpack_require__(28);
	var app = __webpack_require__(30);
	var util = __webpack_require__(32);
	
	function init() {
	  var token = util.getUrlParam('token');
	  var mobile = util.getUrlParam('mobile');
	
	  if (!mobile && !token || mobile && token) {
	    window.location.href = '/';
	  }
	
	  if (!util.isMobile(mobile)) {
	    mobile = '';
	  }
	
	  var html = resetPassword({
	    locale: locale(),
	    actionUrl: '/resetPassword',
	    showCode: !!mobile
	  });
	
	  $('.user-center-wrapper').append(html);
	  //$('#error').css('display', 'block');
	
	  function checkPassword(ele, next) {
	    var val = ele.val();
	    if (util.isPassword(val)) {
	      ele.removeClass('error');
	      next && next();
	    } else {
	      ele.next('label').text(locale('passwordLength'));
	      ele.addClass('error');
	    }
	  }
	
	  if (mobile) {
	    var sms;
	    try {
	      sms = localStorage.getItem('smsCode');
	      if (sms) {
	        localStorage.removeItem('smsCode');
	        getActiveCode($('#getActiveCode'));
	      }
	    } catch (e) {}
	  } else if (token) {
	    $('input[name=token]').val(token);
	  }
	
	  $('#password').blur(function () {
	    checkPassword($(this));
	  }).focus(function () {
	    $(this).removeClass('error');
	  });
	
	  function doSubmit(type) {
	    var data = {
	      password: $('#password').val().trim()
	    };
	    if (type === 'mobile') {
	      data.account = mobile;
	      data.mobileCode = $('#mobile-code').val().trim();
	      data.type = 'mobile';
	    } else if (type === 'email') {
	      data.token = token;
	      data.type = 'email';
	    }
	    ajax({
	      url: '/api/resetPassword',
	      type: 'POST',
	      data: data
	    }, function (ret) {
	      if (ret.success) {
	        util.show(locale('resetSuccess'), 'success', function () {
	          window.location.href = '/login'; ////
	        });
	      } else {
	        util.show(ret.message, 'error');
	      }
	    });
	  }
	  $('.resetpwd-form button.submit').click(function (e) {
	    e.preventDefault();
	
	    checkPassword($('#password'), function () {
	      if (mobile) {
	        checkMobileCode($('#mobile-code'), function () {
	          $('input[name=account]').val(mobile);
	          //$('.resetpwd-form').submit();
	          doSubmit('mobile');
	        });
	      } else {
	        //$('.resetpwd-form').submit();
	        doSubmit('email');
	      }
	    });
	  });
	
	  var checkTimer;
	
	  function checkMobileCode(ele, next) {
	    var code = ele.val().trim();
	    if (util.isActiveCode(code)) {
	      next && next();
	    } else {
	      ele.next('label').text(locale('mobileCodeInvalid'));
	      ele.addClass('error');
	    }
	  }
	  $('#mobile-code').blur(function () {
	    var _this = this;
	
	    checkTimer = setTimeout(function () {
	      checkMobileCode($(_this));
	    }, 100);
	  }).focus(function () {
	    $(this).removeClass('error');
	  });
	
	  function getActiveCode(ele) {
	    if (util.isMobile(mobile)) {
	      util.getActiveCode(ele, mobile);
	    }
	  }
	
	  $('#getActiveCode').click(function (e) {
	    e.preventDefault();
	    getActiveCode($(this));
	  });
	
	  var errorMsg = $('#error').text();
	  if (errorMsg) {
	    util.show(errorMsg, 'error');
	  }
	}
	init();

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(9);
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "	<div class=\"form-item mobile-code\" style=\"position: relative;\">\n    <button id=\"getActiveCode\">"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.getMobileCode : stack1), depth0))
	    + "</button>\n    <input id=\"mobile-code\" class=\"enhancer-input\"  type=\"text\"  name=\"mobileCode\" placeholder=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.mobileCode : stack1), depth0))
	    + "\">\n    <label for=\"mobile-code\"></label>\n    <div class=\"mobile-code-tip\">\n      <a href=\"#1\" tabindex=\"-1\">"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.notMobileCode : stack1), depth0))
	    + "</a>\n    </div>\n  </div>\n  <input type=\"hidden\" name=\"account\" />\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "<h1 class=\"resetpwd-title\">"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.resetPassword : stack1), depth0))
	    + "</h1>\n<form action=\""
	    + alias2(alias1((depth0 != null ? depth0.actionUrl : depth0), depth0))
	    + "\" method=\"post\" role=\"form\" class=\"resetpwd-form\">\n\n  <div class=\"form-item\">\n    <input id=\"password\" class=\"enhancer-input\" type=\"password\" name=\"password\" placeholder=\"New Password\">\n    <label for=\"password\"></label>\n    <input type=\"hidden\" name=\"token\">\n  </div>\n"
	    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.showCode : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "  <div class=\"form-item\">\n    <button class=\"enhancer-btn submit\">"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.submit : stack1), depth0))
	    + "</button>\n  </div>\n</form>";
	},"useData":true});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// resetPassword.js